<template>
  <div>
    <TsIcon
      @click="emit('close')"
      :data-testid="props.dataTestid + '-close-icon'"
      name="system-uicons:cross"
      class="cursor-pointer absolute right-3 top-3 text-black hover:bg-natural-light-grey rounded transition-colors"
    />
    <div class="px-4 md:px-4 mx-auto my-12">
      <TsMedia append-class="mb-5">
        <TsMediaStart
          append-class="bg-white px-2 py-4 md:py-4 rounded-md border-[#DEEFFF] border"
        >
          <TsImage
            v-if="props.image"
            :src="image"
            width="65"
            :alt="props.dataTestid + '-item-image'"
            :data-testid="props.dataTestid + '-item-image'"
            loading="lazy"
          />
        </TsMediaStart>
        <TsMediaContent>
          <TsTypography
            append-class="mb-2"
            variant="h2"
            :data-testid="props.dataTestid + '-heading-text'"
            >{{useTranslation("remove" , "Verwijderen")}}</TsTypography
          >
          <TsTypography
            append-class="mb-0 leading-[18px]"
            :data-testid="props.dataTestid + '-confirmation-text'"
            >{{useTranslation("Trolley-moveFromConfirmation" , "Weet u zeker dat u dit product van de trolley wilt verplaatsen?")}}
          </TsTypography>
        </TsMediaContent>
      </TsMedia>
      <TsColumn append-class="p-0 space-y-2"> 
        <TsButton
          variant="danger"
          outlined
          block
          :data-testid="props.dataTestid + '-remove-cta'"
          @click="emit('remove')"
          >{{useTranslation("remove" , "Verwijderen")}}</TsButton
        >
        <TsButton
          v-if="authStore.is_authenticated"
          block
          @click="emit('saveForLater')"
          :data-testid="props.dataTestid + '-save-for-later-cta'"
          >{{useTranslation("Trolley-moveToMyList" , "Ga naar Mijn lijst")}}</TsButton
        >
        <TsButton
          v-else
          block
          link="/login"
          :data-testid="props.dataTestid + '-login-to-move-to-wish-list-cta'"
          >{{useTranslation("Trolley-loginToMoveToMyList" , "Log in om naar het verlanglijstje te gaan")}}</TsButton
        >
      </TsColumn> 
    </div>
  </div>
</template>

<script setup lang="ts">
import { navigateTo } from "#app";
import { useTranslation } from "~/composables/useTranslation";

const authStore = useAuthStore();

const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);

const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);

type Props = {
  image?: string;
  dataTestid: string;
};

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
  close: any;
  remove: any;
  saveForLater: any;
}>();
</script>